import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import AsyncSelect from 'react-select/async';
import * as styles from './AutoCompleteV2.style';
import { AutoCompleteV2Option } from './components/option/AutoCompleteV2Option';
import AutoCompleteV2LoadingIndicator from './components/loading-indicator/AutoCompleteV2LoadingIndicator';
import { AutoCompleteV2DropdownIndicator } from './components/dropdown-indicator/AutoCompleteV2DropdownIndicator';
import { AutoCompleteV2Input } from './components/input/AutoCompleteV2Input';
export const NO_INPUT_MESSAGE = 'Scrivi per cercare...';
export const NO_OPTIONS_MESSAGE = 'Nessun risultato trovato';
export const LOADING_MESSAGE = 'Caricamento in corso...';
export function AutoCompleteV2(_ref) {
  let {
    id,
    name,
    inputValue,
    value,
    dataRef,
    suggestions,
    icon,
    placeholder,
    error,
    valid,
    disabled,
    minLength,
    isMulti = false,
    clearValueOnSelection = false,
    printSuggestion,
    printLabelSuggestion,
    onChange,
    onBlur,
    onInputChange,
    onSuggestionSelected,
    ...rest
  } = _ref;
  const [loadedOptions, setLoadedOptions] = React.useState([]);
  const [defaultOptions, setDefaultOptions] = React.useState([]);
  const loadOptions = React.useCallback(async internalInputValue => {
    if (internalInputValue.length < minLength) {
      return [];
    }
    let result;
    if (typeof suggestions === 'function') {
      result = await suggestions(internalInputValue);
    } else {
      result = suggestions;
    }
    setLoadedOptions(result);
    return result;
  }, [suggestions, minLength]);
  const isOptionSelected = React.useCallback((option, selectValue) => selectValue.map(currentValue => printSuggestion(currentValue)).includes(printSuggestion(option)), [printSuggestion]);
  const onInternalChange = React.useCallback(newValue => {
    setDefaultOptions(newValue ? loadedOptions : []);
    const customEvent = {
      target: {
        name,
        value: newValue
      }
    };
    if (onChange) {
      onChange(customEvent);
    }
    if (onSuggestionSelected) {
      onSuggestionSelected(newValue);
    }
  }, [loadedOptions, name, onChange, onSuggestionSelected]);
  const onInternalInputChange = React.useCallback((newValue, _ref2) => {
    let {
      action
    } = _ref2;
    if (onInputChange) {
      onInputChange(newValue, action);
    }
  }, [onInputChange]);
  const noOptionsMessage = React.useCallback(_ref3 => {
    let {
      inputValue: internalInputValue
    } = _ref3;
    if (internalInputValue.length < minLength) {
      return NO_INPUT_MESSAGE;
    }
    return NO_OPTIONS_MESSAGE;
  }, [minLength]);
  const loadingMessage = React.useCallback(() => LOADING_MESSAGE, []);
  const components = React.useMemo(() => ({
    DropdownIndicator: props => /*#__PURE__*/React.createElement(AutoCompleteV2DropdownIndicator, _extends({}, props, {
      icon: icon,
      valid: valid,
      error: error
    })),
    IndicatorSeparator: null,
    LoadingIndicator: AutoCompleteV2LoadingIndicator,
    Option: props => {
      const {
        data,
        children
      } = props;
      return /*#__PURE__*/React.createElement(AutoCompleteV2Option, props, printLabelSuggestion ? printLabelSuggestion(data) : children);
    },
    Input: AutoCompleteV2Input
  }), [printLabelSuggestion, icon, error, valid]);
  return /*#__PURE__*/React.createElement(_StyledAsyncSelect, _extends({
    $error: error,
    $valid: valid,
    isSearchable: true,
    isClearable: true,
    id: id,
    isMulti: isMulti,
    name: name,
    value: value,
    inputValue: inputValue,
    "data-ref": dataRef,
    placeholder: placeholder,
    isDisabled: disabled,
    classNamePrefix: "autocomplete",
    defaultOptions: defaultOptions,
    loadOptions: loadOptions,
    noOptionsMessage: noOptionsMessage,
    loadingMessage: loadingMessage,
    isOptionSelected: isOptionSelected,
    getOptionLabel: printSuggestion,
    getOptionValue: printSuggestion,
    onChange: onInternalChange,
    onInputChange: onInternalInputChange,
    onBlur: onBlur,
    components: components,
    controlShouldRenderValue: !clearValueOnSelection
  }, rest, {
    $_css: styles.container
  }));
}
AutoCompleteV2.defaultProps = {
  dataRef: 'autocomplete',
  placeholder: '',
  minLength: 3
};
export default AutoCompleteV2;
var _StyledAsyncSelect = _styled(AsyncSelect).withConfig({
  displayName: "AutoCompleteV2___StyledAsyncSelect",
  componentId: "sc-1qztg0-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=AutoCompleteV2.js.map